import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { DATE_TIME_FORMAT } from '../../constants/date.contant';
import {
  NOTIFICATION_ICON,
  NOTIFICATION_ICON_COLOR,
} from '../../constants/notification.constant';
import { hexToRgba } from '../../services/hex.service';
import IconButtonComponent from '../IconButton.component';
import CrossIcon from '../Icons/Cross.icon';
import { useToast } from '../../hooks/useToast';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../hooks/useAppDispatcher.hook';
import { markAsReadNotificationThunk } from '../../redux/Notification/NotificationThunk';
import { dateFormatter } from '../../utils/formatters';

interface FlyNotifyBlockProps {
  id: string;
  uuid: string;
  type: string;
  sendAt: number;
  title?: string;
  path?: string;
}

const StyledNotificationDate = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;
const StyledNotificationUser = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;

  & > div:nth-child(2) {
    //display: block;
  }
`;
const StyledNotificationType = styled.div`
  font-size: 14px;
  font-weight: 500;
`;
const StyledNotificationAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const StyledNotificationInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;
const StyledNotificationIcon = styled.div<{
  color?: string;
}>`
  display: flex;
  border-radius: 6px;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  background: ${({ color, theme }) =>
    hexToRgba(theme.colors[color || 'LABEL'], 0.1)};
  color: ${({ color, theme }) => theme.colors[color || 'LABEL']};
`;
export const StyledFlyNotifyBlock = styled.div`
  gap: 10px;
  align-items: center;
  display: grid;
  grid-template-columns: 42px auto 42px;
  font-size: 12px;
  cursor: pointer;
`;

const FlyNotifyBlockComponent = ({
  id,
  uuid,
  type,
  sendAt,
  title,
  path,
}: FlyNotifyBlockProps) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { dismissToast } = useToast();

  const handleClick = useCallback(() => {
    path && navigate(path);
    dispatch(markAsReadNotificationThunk(uuid));
    dismissToast(id);
  }, [dispatch, id, uuid, path]);

  return (
    <StyledFlyNotifyBlock onClick={handleClick}>
      <StyledNotificationIcon color={NOTIFICATION_ICON_COLOR[type]}>
        {NOTIFICATION_ICON[type]}
      </StyledNotificationIcon>
      <StyledNotificationInfo>
        <StyledNotificationType>
          {t(`notifications.types.${type}`)}
        </StyledNotificationType>
        {title && (
          <StyledNotificationUser>
            <React.Fragment>
              <div>{t('Candidate')}:</div>
              <div>{title}</div>
            </React.Fragment>
          </StyledNotificationUser>
        )}
        <StyledNotificationDate>
          <div>{t('Date')}:</div>
          <div>{dateFormatter(sendAt, DATE_TIME_FORMAT)}</div>
        </StyledNotificationDate>
      </StyledNotificationInfo>
      <StyledNotificationAction>
        <IconButtonComponent onClick={() => dismissToast(id)}>
          <CrossIcon />
        </IconButtonComponent>
      </StyledNotificationAction>
    </StyledFlyNotifyBlock>
  );
};

export default FlyNotifyBlockComponent;
